import {PolIcon} from "components/PolIcon/policon";
import React from "react";
import {Link} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import {resolveUrl} from "v4/features/front/navigation/utils/route.utils";
import PdfButton from "v4/features/front/generatePdf/components/PdfButton/PdfButton";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function ActionsButtonsPdf({files, quoteId, quoteName, prospectId, contactIds, updateHandler, currentFile, registerOpenModal}) {
    const {t} = usePolTranslation()
    const {getRouteByNativeIdentifier} = useNavigation()

    return (
        <>
            <PdfButton files={files}
                       quoteId={quoteId}
                       quoteName={quoteName}
                       registerOpenModal={registerOpenModal}
                       updateHandler={updateHandler}/>

            {currentFile?.length > 0
                ? (
                    <>
                        <Link className="prospect-tab__prospect__header__action"
                              data-for="send-pdf-mail"
                              data-tip={t('send_by_mail')}
                              to={{
                                  pathname: `/${resolveUrl(getRouteByNativeIdentifier('detail_contacts')?.url, {prospect: prospectId})}/mail`,
                                  search: `?quoteId=${quoteId}`,
                                  state: {
                                      mailContactIds: contactIds,
                                  }
                              }}>
                            <PolIcon icon="mails-send"/>
                        </Link>
                        <ReactTooltip id="send-pdf-mail" effect="solid"/>
                    </>
                )
                : (
                    <button className="prospect-tab__prospect__header__action"
                            data-for="send-pdf-mail"
                            data-tip={t('send_by_mail')}
                            disabled>
                        <PolIcon icon="mails-send"/>
                    </button>
                )
            }
        </>
    )
}
